export default __webpack_public_path__ + "static/media/mic.3c836872.svg";